import { SHOW_MANAGER_APPROVAL, HIDE_MANAGER_APPROVAL, SETUP_MANAGER_APPROVAL } from './ActionTypes'

export const openManagerApproval = () => ({ type: SHOW_MANAGER_APPROVAL })

export const hideManagerApproval = () => ({ type: HIDE_MANAGER_APPROVAL })

export const setManagerApprovalPrompt = ({ onSuccess, onFailure, buttonText, isOpen = true }) => ({
  type: SETUP_MANAGER_APPROVAL,
  payload: { onSuccess, onFailure, buttonText, isOpen },
})
